// Dummy authentication function
import {Navigate, Outlet} from "react-router-dom";
import {getStore, setStore} from "trim-redux";
import {useSnackbar} from "notistack";
import * as React from "react";
import axios from "axios";
import {defaultVariables} from "./index";
import {hasPanel, isAdmin} from "./Permissions";

export const PrivateRoute = ({ element,role,panel }) => {
    setStore(({
        global_menu:"home"
    }))
    return (!!getStore('isAuth') && (!!role ? getStore('user').role.name === role : true) ) &&(!!panel ? hasPanel() : true) ?
        element
        :
        <Navigate to="/login" replace />;
};
export const RoleRestrict = ({ role }) => {
    return (!!role ? getStore('user').role.name === role : false)  ? <Outlet/> : <Navigate to="/login" replace />;
};
export const Snackbar = (text,option) => {
    const { enqueueSnackbar } = useSnackbar();
    enqueueSnackbar(text,option);
}
export const updateRedux = async () => {
    const loginToken = localStorage.getItem('ACT');
    if (loginToken) {
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        await axios.get(`${defaultVariables.url}/auth/check-login`, config)
            .then(async response => {
                await setStore({
                    isAuth: true,
                    user: response.data,
                });
            })
            .catch(async error => {
                console.log(error.response);
                await setStore({
                    isAuth: false,
                    user: null,
                });
            });
    } else {
        setStore({
            isAuth: false,
            user: null,
        });
    }
};
export const loadSetting = async () => {
    const config = {
        headers: {
            Accept: 'application/json',
        }
    };
    await axios.get(`${defaultVariables.url}/settings/get-all`, config)
        .then(response => {
            setStore({
                setting: response.data,
                primary_color: response.data.primary_color,
                secondary_color: response.data.secondary_color,
                app_name: response.data.app_name,
            });
        })
        .catch(error => {
            console.log(error.response);
        });
};